<!-- banner 首页 -->
<template>
  <div class="banner" :style="`background-image:url(${bgUrl});`">
    <div class="container-1600 relative">
      <div class="banner-link absolute">
        <a
          :href="recruitCateUrl"
          target="_blank"
          class="group mt-[52px] inline-block rounded-[29px] px-[29px] transition-shadow hover:shadow-lg"
          style="background-color: #fff;"
        >
          <div class="flex h-[46px] items-center" style="color:#32a5a1;">
            加入我们
            <Icon
              icon="bi:arrow-right"
              class="ml-[12px] inline-block text-[25px] transition-all group-hover:ml-[20px]"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2';

export default {
  name: 'BannerIndex',
  components: {
    Icon,
  },
  computed: {
    recruitCateUrl() {
      let url = this.$store.state.recruitCate[0].url;
      return url;
    },
    bgUrl() {
      let temp = this.$store.state.navCate.filter((item) => {
        if (item.resmenu_id === '1') {
          return item;
        }
      });
      return temp[0] ? temp[0].pic : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  height: 933px;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
}
.banner-link {
  left: 43%;
  top: 377px;
}
@media screen and (max-width: 1600px) {
  .banner {
    height: 800px;
    background-size: 100%;
  }
  .banner-link {
    top: 300px;
  }
}
@media screen and (max-width: 1300px) {
  .banner {
    height: 650px;
  }
  .banner-link {
    top: 250px;
  }
}
@media screen and (max-width: 1000px) {
  .banner {
    height: 500px;
  }
  .banner-link {
    top: 180px;
  }
}
@media screen and (max-width: 768px) {
  .banner {
    background-size: 230%;
    background-position: left top;
  }
  .banner-link {
    top: 300px;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media screen and (max-width: 500px) {
  .banner {
    background-size: 350%;
  }
}
</style>
